import { render } from "./AssinaturaForm.vue?vue&type=template&id=c2065c2e"
import script from "./AssinaturaForm.vue?vue&type=script&lang=js"
export * from "./AssinaturaForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./AssinaturaForm.vue?vue&type=style&index=1&id=c2065c2e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__